import { Avatar, Box, Button, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import AddUpdateAnnouncementDailog from "../../../../Component/Dailog/web/AddUpdateAnnouncement";
import {
  DELETE_ANNOUNCEMENT,
  GET_ANNOUNCEMENT,
} from "../../../../Apis/web/announcement_api";
import DataGrideView from "../../../../Component/DataGrideView/DataGrideView";
import { API_URL } from "../../../../Apis/config";
import SplitButton from "../../../../Component/Button/SplitButton";
import ConfirmationDailog from "../../../../Component/Dailog/ConfirmationDailog";
import { dateFormateMMDDYYYHHMMSS } from "../../../../Service/DateSevice";

function Announcement() {
  const [open, setOpen] = useState(false);
  const [row, setRow] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [isLoading, SetIsLoading] = useState(true);

  const getData = async () => {
    SetIsLoading(true);
    const res = await GET_ANNOUNCEMENT();

    if (res && res?.s) {
      setRow(res?.r ?? []);
    } else {
      setRow([]);
    }
    SetIsLoading(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = (v) => {
    if (v) {
      getData();
    }
    setSelectedRow(null);
    setOpen(false);
  };

  const handleCloseDelete = async (v) => {
    if (v) {
      await DELETE_ANNOUNCEMENT(selectedRow.id);
      getData();
    }
    setSelectedRow(null);
    setDeleteOpen(false);
  };

  useEffect(() => {
    getData();
  }, []);

  const columns = [
    {
      field: "id",
      headerName: "SR.",
      filterable: false,
      headerAlign: "center",
      align: "center",
      width: 100,
      minWidth: 100,
      renderCell: (params) => {
        // console.log(params);
        return params.api.getRowIndex(params.row.id) + 1;
      },
    },
    {
      field: "name",
      headerName: "Name",
      filterable: false,
      maxWidth: 110,
      headerAlign: "left",
      align: "left",
      renderCell: (params) => {
        // console.log(params);
        return (
          <Typography sx={{ py: 1, fontSize: "13px" }}>
            {params.value}
          </Typography>
        );
      },
    },
    {
      field: "description",
      headerName: "Description",
      filterable: false,
      minWidth: 200,
      flex: 1,
      headerAlign: "left",
      align: "left",
      renderCell: (params) => {
        return (
          <Typography sx={{ py: 1.5, fontSize: "13px" }}>
            {params.value}
          </Typography>
        );
      },
    },
    {
      field: "photo_1",
      headerName: "Photo One",
      filterable: false,
      maxWidth: 80,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        return (
          <Avatar
            sx={{ height: "30px", width: "30px" }}
            src={API_URL.baseUrl + API_URL.webAnnouncementImage + params.value}
          />
        );
      },
    },
    {
      field: "photo_2",
      headerName: "Photo Two",
      filterable: false,
      maxWidth: 80,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        return (
          <Avatar
            sx={{ height: "30px", width: "30px" }}
            src={API_URL.baseUrl + API_URL.webAnnouncementImage + params.value}
          />
        );
      },
    },
    {
      field: "created_at",
      headerName: "Created Date",
      minWidth: 220,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        return (
          <Typography> {dateFormateMMDDYYYHHMMSS(params.value)}</Typography>
        );
      },
    },

    {
      field: "action",
      headerName: "Action",
      maxWidth: 70,

      flex: 1,
      type: "number",
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <SplitButton
          key={params.id}
          title={params.value}
          // isView={rightsUser.includes(4) ? 1 : null}
          dataId={params.row.id}
          isDelete={1}
          isEdit={1}
          onEdit={onEdit}
          onView={null}
          onDelete={onDelete}
          // deleteText="Delete"
        />
      ),
    },
  ];

  const onEdit = (id) => {
    // console.log(id, "id");
    setSelectedRow(() => row.find((v) => v.id == id));
    setOpen(true);
  };

  const onDelete = (id) => {
    setSelectedRow(() => row.find((v) => v.id == id));
    setDeleteOpen(true);
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "flex-end",
          flexDirection: "column",
        }}
      >
        <Button
          variant="outlined"
          sx={{
            width: "200px",
            mb: 1,
          }}
          onClick={handleOpen}
        >
          <Typography sx={{ color: "primary.main" }}>
            Add Announcement{" "}
          </Typography>
        </Button>

        <Box sx={{ boxShadow: "3px 3px 7px 0px #00000040", width: "100%" }}>
          <DataGrideView
            rows={row}
            columns={columns}
            // callBack={callBack}
            isLoading={isLoading}
            sx={{
              height: "75vh",
            }}
            autoHeight={true}
          />
        </Box>
      </Box>
      {open && (
        <AddUpdateAnnouncementDailog
          open={open}
          handleOnClose={handleClose}
          row={selectedRow}
        />
      )}

      {deleteOpen && (
        <ConfirmationDailog
          handleOnClose={handleCloseDelete}
          open={deleteOpen}
          content="Are you sure, You want to delete this announcement?"
          title="Delete Announcement!"
        />
      )}
    </>
  );
}

export default Announcement;
